import Title from './Title';
import GameArea from './GameArea';
import React from 'react';
import Settings from './Settings';
import ReportForm from './ReportForm';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      wordLength: 5,
      maxGreen: 2,
      maxYellow: 3,
    }

    let cookie = decodeURIComponent(document.cookie);
    let ca = cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf("preferences=") === 0) {
        this.state = JSON.parse(c.substring(12, c.length));
      }
    }
  }

  setParameters(wordLength=5, maxGreen=2, maxYellow=3) {
    this.setState({
      wordLength: wordLength,
      maxGreen: maxGreen,
      maxYellow: maxYellow,
    }, () => {
      this.refresh();

      const d = new Date();
      d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = "preferences=" + JSON.stringify(this.state) + ";" + expires + ";path=/";
    })
  }

  render() {
    return (
      <div className="game">
        <Settings openSettings={call => this.openSettings = call} setParameters={this.setParameters.bind(this)} wordLength={this.state.wordLength} maxGreen={this.state.maxGreen} maxYellow={this.state.maxYellow} />
        <ReportForm openReport={call => this.openReport = call} getWords={() => this.getWords()} />
        <Title
          openSettings={() => this.openSettings()}
          openReport={() => this.openReport()}
          giveUp={() => this.giveUp()}
        />
        <GameArea
          parameters={this.state}
          giveUp={call => this.giveUp = call}
          refresh={call => this.refresh = call}
          getWords={call => this.getWords = call}
        />
      </div>
    );
  }
}

export default App;
